"use client";

import { useEffect } from "react";
import Link from "next/link";
import { RiArrowLeftLine, RiErrorWarningLine } from "@remixicon/react";
import { Button } from "@/modules/system/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-4">
            <RiErrorWarningLine className="h-12 w-12 text-destructive" />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold tracking-tight">Something went wrong</h1>
        
        <p className="text-muted-foreground">
          We&apos;re sorry, but something unexpected happened. Our team has been notified.
        </p>
        
        <div className="flex flex-col gap-2 pt-4">
          <Button onClick={reset} className="w-full">
            Try again
          </Button>
          
          <Button asChild variant="outline" className="w-full">
            <Link href="/">
              <RiArrowLeftLine className="mr-2 h-4 w-4" />
              Back to Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
} 